module.exports = __webpack_public_path__ + "static/media/Прямикова Елена Леонидовна Каждый должен начать с себя. Мурманская обл.-4.png";